import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle
} from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import Button from 'material-ui/Button';

import * as AppState from '../../state/reducer/app/appState';
import Console from '../../lib/debug';

class ErrorDialog extends Component {
    handleClose = () => {
        AppState.clearError();
    };
    render() {
        Console.render('ErrorDialog');

        const speedKills =
            'https://static.trainheroic.com/images/speedkills.gif';
        return (
            <Dialog
                open={this.props.appError}
                onClose={this.handleClose}
                aria-labelledby="App-Error-Dialog"
                className="th-dialog error-dialog"
            >
                <DialogTitle>Oh no.</DialogTitle>
                <DialogContent>
                    <img src={speedKills} alt="Speed Kills" />
                    <br />
                    <br />
                    <p>
                        Oops, Looks like we missed that rep. Please refresh the
                        page and give it another shot.
                    </p>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={this.handleClose}>OK</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        appError: state.app.appError
    };
};

export default connect(mapStateToProps)(ErrorDialog);
